import { render, staticRenderFns } from "./ProjectSectionSort.vue?vue&type=template&id=26ccdf99&scoped=true&"
import script from "./ProjectSectionSort.vue?vue&type=script&lang=ts&"
export * from "./ProjectSectionSort.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSectionSort.vue?vue&type=style&index=0&id=26ccdf99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ccdf99",
  null
  
)

export default component.exports